var _rect, _path, _g, _g2, _g3, _mask, _path2, _path3, _rect2, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCollectionIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-5853 -467C-5853 -468.104 -5852.1 -469 -5851 -469H1026C1027.1 -469 1028 -468.105 1028 -467V7868C1028 7869.1 1027.1 7870 1026 7870H-5851C-5852.1 7870 -5853 7869.1 -5853 7868V-467Z",
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1020,
    transform: "translate(-1113 -63)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 327,
    y: -63,
    width: 50.0001,
    height: 1440,
    transform: "rotate(90 327 -63)",
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.5,
    y: -63.5,
    width: 51.0001,
    height: 1441,
    transform: "rotate(90 327.5 -63.5)",
    stroke: "url(#paint0_linear_0_1)",
    strokeOpacity: 0.5,
    shapeRendering: "crispEdges"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1020,
    transform: "translate(-1113 -63)",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 327,
    y: -66,
    width: 50.0001,
    height: 1440,
    transform: "rotate(90 327 -66)",
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.5,
    y: -66.5,
    width: 51.0001,
    height: 1441,
    transform: "rotate(90 327.5 -66.5)",
    stroke: "url(#paint1_linear_0_1)",
    strokeOpacity: 0.5,
    shapeRendering: "crispEdges"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-1_0_1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-676 -14H327V26H-676V-14Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-676 -14H327V26H-676V-14Z",
    fill: "#F2F2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M326 -14V26H328V-14H326Z",
    fill: "#D4D4D4",
    mask: "url(#path-7-inside-1_0_1)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -6,
    y: -6,
    width: 23,
    height: 23,
    rx: 3,
    fill: "#535353"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9 2.93333V2.56667C9.9 1.96033 9.40633 1.46667 8.8 1.46667V1.1C8.8 0.493668 8.30633 0 7.7 0H3.3C2.69367 0 2.2 0.493668 2.2 1.1V1.46667C1.59367 1.46667 1.1 1.96033 1.1 2.56667V2.93333C0.493668 2.93333 0 3.427 0 4.03333V9.9C0 10.5063 0.493668 11 1.1 11H9.9C10.5063 11 11 10.5063 11 9.9V4.03333C11 3.427 10.5063 2.93333 9.9 2.93333ZM2.93333 1.1C2.93333 0.898052 3.09805 0.733333 3.3 0.733333H7.7C7.90195 0.733333 8.06667 0.898052 8.06667 1.1V1.46667H2.93333V1.1ZM1.83333 2.56667C1.83333 2.36472 1.99805 2.2 2.2 2.2H8.8C9.00195 2.2 9.16667 2.36472 9.16667 2.56667V2.93333H1.83333V2.56667Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-5851 -468H1026V-470H-5851V-468ZM1027 -467V7868H1029V-467H1027ZM1026 7869H-5851V7871H1026V7869ZM-5852 7868V-467H-5854V7868H-5852ZM-5851 7869C-5851.55 7869 -5852 7868.55 -5852 7868H-5854C-5854 7869.66 -5852.66 7871 -5851 7871V7869ZM1027 7868C1027 7868.55 1026.55 7869 1026 7869V7871C1027.66 7871 1029 7869.66 1029 7868H1027ZM1026 -468C1026.55 -468 1027 -467.552 1027 -467H1029C1029 -468.657 1027.66 -470 1026 -470V-468ZM-5851 -470C-5852.66 -470 -5854 -468.657 -5854 -467H-5852C-5852 -467.552 -5851.55 -468 -5851 -468V-470Z",
    fill: "black",
    fillOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_0_1",
    x: -1154,
    y: -104,
    width: 1522,
    height: 132,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_0_1",
    result: "effect2_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_0_1",
    x: -1137,
    y: -86,
    width: 1488,
    height: 98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 377,
    y1: 714,
    x2: 327,
    y2: 576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 377,
    y1: 711,
    x2: 327,
    y2: 573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1020,
    fill: "white",
    transform: "translate(-1113 -63)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1020,
    fill: "white",
    transform: "translate(-1113 -63)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectionIcon);
export default __webpack_public_path__ + "static/media/collection_icon.759dd80a0586334ba0ffde7b75328f01.svg";
export { ForwardRef as ReactComponent };